/**
 * Amizek Delayed Loader
 * Loads declared performance and storefront enhancement scripts after the page is ready.
 */
(function () {
  'use strict';

  function isAllowedAsset(url) {
    if (!url || typeof url !== 'string') return false;
    return true;
  }

  function uniqueAssets(urls) {
    var seen = Object.create(null);
    return urls.filter(function (url) {
      if (!isAllowedAsset(url) || seen[url]) return false;
      seen[url] = true;
      return true;
    });
  }

  function loadDeferredScripts() {
    var sourceAssets = [];
    if (Array.isArray(window.amizekOptimizationAssets)) {
      sourceAssets = sourceAssets.concat(window.amizekOptimizationAssets);
    }
    if (Array.isArray(window.amizekAdminDashboardAssets) && window.amizekAdminEnabled) {
      sourceAssets = sourceAssets.concat(window.amizekAdminDashboardAssets);
    }

    var safeAssets = uniqueAssets(sourceAssets);
    if (!safeAssets.length) return;

    var fragment = document.createDocumentFragment();
    safeAssets.forEach(function (url) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.defer = true;
      fragment.appendChild(script);
    });
    document.body.appendChild(fragment);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadDeferredScripts, { timeout: 4000 });
  } else {
    window.addEventListener('load', function () {
      setTimeout(loadDeferredScripts, 3000);
    });
  }
})();
